// extracted by mini-css-extract-plugin
export var active = "_bo-2";
export var highlight = "_bo-1";
export var highlightLayer = "_bo-0";
export var issuePopover = "_bo-3";
export var statusIcon = "_bo-4";